import React, { useEffect, useRef, useState } from "react";
import "./Header.scss";
import Logo from "../../../images/easypayLogo.png";
import { Link, useLocation } from "react-router-dom";
import { partnerDetails } from "../../../util/utils";
import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";

const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "hi", label: "हिंदी", short: "हि" },
  { code: "mr", label: "मराठी", short: "म" },
  { code: "gu", label: "ગુજરાતી", short: "ગુ" },
];

function Header({ handleLocation, baas }) {
  const location = useLocation();
  let domainDetail = partnerDetails();
  const headerRef = useRef(null);
  const { t, i18n } = useTranslation();
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const langDropdownRef = useRef(null);

  useEffect(() => {
    const handleLangClickOutside = (event) => {
      if (langDropdownRef.current && !langDropdownRef.current.contains(event.target)) {
        setIsLangDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleLangClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleLangClickOutside);
    };
  }, []);

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem("i18nextLng", langCode);
    setIsLangDropdownOpen(false);
  };
  // Animated Header
  const changeHeader = () => {
    if (window.scrollY > 10) {
      headerRef.current &&
        (headerRef.current.style.boxShadow =
          "0px 1px 6px 0px rgba(32, 33, 36, 0.28)");
    } else {
      headerRef.current && (headerRef.current.style.boxShadow = "none");
    }
  };
  window.addEventListener("scroll", changeHeader);

  return (
    <header id="header" ref={headerRef}>
      <a className="sell-link" href="index.html">
        <img
          src={domainDetail?.partnerLogoPath || Logo}
          alt="logo"
          className="easypay-logo"
        />
      </a>
      <nav>
        <ul>
          <li className="nav-item position-relative" ref={langDropdownRef}>
            <div
              className="nav-link profile-link lang-switcher-btn"
              onClick={() => setIsLangDropdownOpen((prev) => !prev)}
            >
              <span className="menu-title">
                <MdLanguage
                  style={{ fontSize: "18px", verticalAlign: "middle", marginRight: "3px" }}
                />
                {LANGUAGES.find((l) => l.code === i18n.language)?.label || "English"}
                <span id="down-arrow" className="arrow">
                  <IoIosArrowDown />
                </span>
              </span>
            </div>
            {isLangDropdownOpen && (
              <div className="lang-dropdown-menu position-absolute start-0">
                {LANGUAGES.map((lang) => (
                  <div
                    key={lang.code}
                    className="p-drop-item"
                    onClick={() => handleLanguageChange(lang.code)}
                  >
                    <span
                      className={`menu-title${i18n.language === lang.code ? " active-lang" : ""}`}
                    >
                      {lang.label}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </li>
          <li className="stick"></li>
          <li className="register" onClick={handleLocation}>
            <Link
              to={
                location.pathname === "/baas/login" ||
                location.pathname === "/baas/reset" ||
                location.pathname === "/baas/forget" ||
                location.pathname === "/baas/otp"
                  ? "/baas/registration"
                  : location.pathname === "/baas/ONDC/login" &&
                    "/baas/ONDC/registration"
              }
              className="header-link"
            >
              {t("header.registerHere")}
            </Link>
          </li>
          <li className="stick"></li>
          <li onClick={handleLocation}>
            <Link
              to={
                location.pathname === "/baas/registration" ||
                location.pathname === "/baas/reset" ||
                location.pathname === "/baas/forget" ||
                location.pathname === "/baas/otp"
                  ? "/baas/login"
                  : location.pathname === "/baas/ONDC/registration" &&
                    "/baas/ONDC/login"
              }
              id="login"
              className="header-link"
            >
              {t("header.login")}
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
